<template>
  <figure
    class="checkimage"
    :class="{ 'is-checked': value, 'is-single': single }"
    @click="$emit('input', !value)"
  >
    <div class="checkimage-box">
      <img :src="src" alt="" />
      <span class="checkimage-toggle"></span>
    </div>
    <figcaption class="checkimage-label">
      <slot></slot>
      <input type="checkbox" :value="value" />
    </figcaption>
  </figure>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    },
    single: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
